import React, { Component, Fragment } from 'react'
import { withRouter } from 'react-router-dom'
import NotesMenu from '../components/NotesMenu'
import TopBarLayout from '../layouts/TopBarLayout'
import { observer } from 'mobx-react'
import patient from '../stores/patient'

@observer
class EditPatientLayout extends Component {
  render() {
    const { title, children } = this.props

    return (
      <Fragment>
        <NotesMenu />
        <TopBarLayout
          title={title}
          backHref={patient.fields && patient.fields.demo ? '/demo' : "/patients"}
          backText={patient.fields && patient.fields.demo ? 'Demo' : 'Patients'}
        >
          {children}
        </TopBarLayout>
      </Fragment>
    )
  }
}

export default withRouter(EditPatientLayout)



// WEBPACK FOOTER //
// ./src/layouts/EditPatientLayout.js